// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__23SJ0","paymentContainer":"PaymentPage_paymentContainer__1qGcY"};